import { DriveInput } from "../types";
import {
  twoStepFeedTrigger,
  menuAnchor,
  guidedTourLink,
  standardDriverData,
} from "../helpers";

export const feedDriverTitle = "Upload Products";

const stepsData: DriveInput[] = [
  {
    description:
      "To get started go to the Site section. There you can upload your feed data and keep them up to date.",
    stepTitle: "Site Section",
  },
  {
    description: "Click Upload button to open the corresponding settings.",
    stepTitle: "Product Upload",
    anchorElement: "#uploadFeedButton",
    onNextClick: async () =>
      await twoStepFeedTrigger("uploadFeedButton", "url0", true),
  },
  {
    description: `Provide a CSV following the ${guidedTourLink(
      "https://support.google.com/merchants/answer/7052112",
      "google shopping product feed specification",
    )}.`,
    stepTitle: "CSV Format",
    anchorElement: "#url0",
    side: "bottom",
    align: "center",
    step: (
      <>
        Provide a CSV following the{" "}
        {guidedTourLink(
          "https://support.google.com/merchants/answer/7052112",
          "google shopping product feed specification",
          false,
        )}
        .
      </>
    ),
    onPreviousClick: async () => {
      const closeButton = document.getElementsByClassName(
        "absolute right-3.5 top-3.5",
      );
      if (closeButton.length > 0) (closeButton[0] as HTMLButtonElement).click();
      return true;
    },
  },
  {
    description:
      "Shortly after starting the import you will see your products on the products page. In the background the products will be analysed by vviinn`s AI. It might take up to 24 hours until all products can be seen.",
    stepTitle: "Start Import",
    anchorElement: ".acceptButton",
    onNextClick: () => {
      const acceptButton = document.querySelector(
        ".acceptButton",
      ) as HTMLButtonElement;
      if (acceptButton) {
        if (!acceptButton.disabled) {
          acceptButton.click();
        } else {
          const closeButton = document.getElementsByClassName("closeButton");
          if (closeButton.length > 0)
            (closeButton[0] as HTMLButtonElement).click();
        }
      }
      return true;
    },
    side: "top",
    align: "center",
  },
];

export const productsFeedGuide = () => {
  const zeroItemId = menuAnchor("Site");
  const feedData = standardDriverData(feedDriverTitle, stepsData, zeroItemId);

  feedData.driverData.stepsData[0].onNextClick = async () =>
    await twoStepFeedTrigger(zeroItemId, "uploadFeedButton");
  return feedData;
};
